import styled from 'styled-components';

import { Link } from 'react-router-dom';

import MaskImage from 'assets/img/hexa-mask-2.png';

export const Container = styled(Link)`
  width: calc(100% - 20px);
  max-width: 400px;
  height: 50px;

  display: flex;
  justify-content: flex-start;
  gap: 10px;
  align-items: center;

  position: relative;
  left: 10px;

  border-radius: 0 5px 5px 0;
  text-decoration: none;
  border: 0;
  outline: none;
  background-color: transparent;
  cursor: pointer;
  transition: filter 0.2s;

  .hex-icon-button__icon-container{
    width: 57px;
    height: 57px;

    position: relative;
    right: 20px;

    background-color: var(--blue00);

    mask-image: url(${MaskImage});
    mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: center;
  }

  .hex-icon-button__icon{
    height: auto;
    width: 100%;
    margin-top: 2px;
  }

  .hex-icon-button__text{
    width: fit-content;
    height: fit-content;

    font-size: 1.4rem;
    font-weight: bold;
    color: var(--blue00);
  }

  &:nth-child(even){
    background-color: var(--blueE5);
  }

  &:nth-child(odd){
    background-color: var(--bluef0);
  }

  &:hover {
    filter: brightness(1.1);
  }
`
